import { Box, Heading, Modal, VStack, motion } from '@hover/blueprint';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

import { LoadingTextEllipsis } from 'src/modules/homeownerApp/components/LoadingText';
import { UploadImageBox } from 'src/modules/homeownerApp/components/UploadImage/UploadImageBox';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type OverlayLoadingProps = {
  header?: string;
  imageUrl?: string;
};

const MotionVStack = motion(VStack);

export const OverlayLoading = ({ header, imageUrl }: OverlayLoadingProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  if (!imageUrl) return null;

  return (
    <Modal
      contentProps={{
        alignItems: 'center',
        backgroundColor: 'neutral.0',
        justifyContent: 'center',
        w: 1,
        p: 0,
      }}
      isClosable={false}
      isOpen
      onClose={() => undefined}
      size="full"
    >
      <AnimatePresence>
        <MotionVStack
          animate={{ opacity: 1 }}
          gap={0}
          height="100dvh"
          initial={{ opacity: 0 }}
        >
          <UploadImageBox
            borderRadius={350}
            height="100%"
            imageUrl={imageUrl}
            maxW={{ base: '80%' }}
            pt={{ tablet: 900 }}
          />
          <Box
            alignItems="center"
            flex={{ base: 1.5, tablet: 1 }}
            flexDir="column"
            pt={{ base: '700 !important', tablet: '900 !important' }}
          >
            <Heading
              mb={0}
              textStyle={{ base: 'headingMedium', tablet: 'headingXl' }}
            >
              {header || t('projects.projectCreation.creatingProject')}
            </Heading>
            <Heading textStyle={{ base: 'headingMedium', tablet: 'headingXl' }}>
              <LoadingTextEllipsis />
            </Heading>
          </Box>
        </MotionVStack>
      </AnimatePresence>
    </Modal>
  );
};
